<template lang='pug'>
  div
    v-navigation-drawer.hidden-md-and-up(v-model='drawer', clipped='', temporary='', app='')
      v-list
        v-list-tile(v-if='scheduleActivated' href='https://agendamento.ultrahealth.care/')
          v-list-tile-action
            v-icon(v-html='"calendar_month"')
          v-list-tile-content
            v-list-tile-title
              | {{ 'Agendamento' }}
        v-list-tile(v-for='(item, i) in items', :to='item.link', v-if="!item.roles || item.roles.includes(user.role)", :key='i')
          v-list-tile-action
            v-icon(v-html='item.icon')
          v-list-tile-content
            v-list-tile-title
              | {{ item.title | capitalize }}
    v-toolbar.primary(app='', dark='', dense='')
      v-toolbar-side-icon.hidden-md-and-up(@click.stop='drawer = !drawer')
      v-toolbar-items.hidden-sm-and-down
        v-btn(flat='', to='/')
          img.ml-3(src='/static/icon.ico', height='38')
        v-btn( v-if='scheduleActivated' flat='', href='https://agendamento.ultrahealth.care/')
          | {{ 'Agendamento' }}
        v-btn(flat='', v-for='(item, i) in items', :key='i', :to='item.link', v-if="item.link !== '/' && (!item.roles || item.roles.includes(user.role))")
          | {{ item.title }}
      v-spacer
      v-menu(offset-y)
        v-btn(slot='activator' flat) {{ companyName }}
          v-icon arrow_drop_down
        v-list(subheader dense)
          v-subheader {{ $t('words.companies') | capitalize }}
          v-list-tile(
            v-for="company in companiesSorted"
            :key="company.id"
            @click="changeCompany(company.identity)"
          )
            v-list-tile-title {{ company.name }}
          v-subheader {{user.displayName}}
          v-list-tile(href="https://my.anydesk.com/v2/api/v2/custom-clients/downloads/public/WVG76ZW3XSGG/SuporteUHC.exe.")
            v-list-tile-avatar(style="min-width:30px")
              v-icon.pr-1 cloud_download
            v-list-tile-content {{ $t('words.remoteSupport') | capitalize }} 
          v-list-tile(to='/profile')
            v-list-tile-title {{ $t('words.profile') | capitalize }}
          v-list-tile(@click='signOut')
            v-list-tile-title {{ $t('words.logout') | capitalize }}
      uf-toolbar-languages
    v-content.page-container
      router-view
</template>

<script>
import { auth } from '@/store/firebase'
import { mapState } from 'vuex'
import { store } from '@/store'

import UfToolbarLanguages from '@/components/ultra-fetal/core/Locales'

export default {
  name: 'Main',

  components: {
    UfToolbarLanguages
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
      company: (state) => state.company,
      companies: (state) => state.companies,
      isAdmin: state => state.user.role === 'admin'
    }),
    title () {
      return this.$route.name
    },
    companyName () {
      let c = this.companies.find(item => item.identity === this.company)
      return c ? c.name : 'Empresa não encontrada'
    },
    scheduleActivated () {
      let c = this.companies.find(item => item.identity === this.company)
      if (c && c.schedule && c.schedule.activated) {
        return true
      } else {
        return false
      }
    },
    companiesSorted () {
      return this.companies.sort((a, b) => {
        if (a.name.toUpperCase() < b.name.toUpperCase()) {
          return -1
        }
        if (a.name.toUpperCase() > b.name.toUpperCase()) {
          return 1
        }
        return 0
      })
    }
  },

  data () {
    return {
      drawer: false,
      items: [
        {
          icon: 'home',
          title: this.$t('words.home'),
          link: '/'
        },
        {
          icon: 'person',
          title: this.$tc('words.patient', 2),
          link: '/patients'
        },
        {
          icon: 'list',
          title: this.$t('words.studies'),
          link: '/studies'
        },
        {
          icon: 'list',
          title: this.$t('words.companies'),
          link: '/companies',
          roles: ['admin']
        },
        {
          icon: 'list',
          title: this.$t('words.users'),
          link: '/users',
          roles: ['admin']
        }
      ]
    }
  },
  methods: {
    changeCompany (id) {
      store.dispatch('setCompany', id)
      this.$router.push('/')
    },
    signOut () {
      auth.signOut()
      .then((res) => {
        this.$router.push('/login')
      })
      .catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>

<style scoped>
  .page-container {
      max-width: 1185px !important;
      padding-top: 75px;
      padding-bottom: 0;
      transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
      flex: 1 1 100%;
      margin: auto;
      padding: 24px;
      width: 100%;
  }
  @media only screen and (min-width: 1264px) {
    .page-container {
        max-width: 1185px;
    }
  }
  @media only screen and (min-width: 960px) {
    .page-container {
        max-width: 900px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Main.vue